import React from 'react';
import { withTranslation } from 'react-i18next';

import { getRoleLabel } from '../../utils/user';

import SearchField from './search-field';
import RoleSelector from '../role-selector';

class UserSearchField extends SearchField {
    state = {
        role: this.props.role
    }

    handleRoleChange = role => {
        if (this.props.roleSelectorDisabled) {
            return;
        }

        this.setState({ role });

        this.props.onRoleChange && this.props.onRoleChange(role);
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value && this.props.value !== this.state.value) {
            this.setState({
                value: this.props.value
            });
        }

        if (this.props.role !== prevProps.role && this.props.role !== this.state.role) {
            this.setState({
                role: this.props.role
            });
        }
    }

    get currentRoleTitle() {
        return getRoleLabel(this.state.role);
    }

    get roleSelectorEnabled() {
        return this.props.roles;
    }

    get placeholder() {
        const { placeholder, t } = this.props;

        return placeholder ?? t('Enter email');
    }

    render() {
        return (
            <div className={'search-field user-search-field expanded' + (this.props.className || '') + (this.state.focus ? ' focus' : '') + (this.populated ? ' populated' : '') + (!this.roleSelectorEnabled ? ' no-role-selector' : '') + (this.props.error ? ' error' : '')}>
                <span className="field-icon">
                    <i className="material-icons">person</i>
                </span>

                <input
                    type="search"
                    className="field-input"
                    ref={(element) => {this.inputFieldElement = element}}
                    placeholder={this.placeholder}
                    value={this.state.value}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    onKeyDown={this.props.onKeyDown}
                />

                {
                    this.roleSelectorEnabled ?
                        <RoleSelector onChange={this.handleRoleChange} disabled={this.props.roleSelectorDisabled} roles={this.props.roles} value={this.state.role}>
                            <span className="value">
                                {this.currentRoleTitle}
                            </span>

                            {
                                this.props.roles.length > 1 && !this.props.roleSelectorDisabled ? (
                                    <span className="arrow">
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </span>
                                ) : null
                            }
                        </RoleSelector>
                    : null
                }
            </div>
        );
    }
}

export default withTranslation('common')(UserSearchField);
